import fetch from "../components/optionsFetch";
import * as React from "react";
import DataGrid from "../components/DataGrid";
import GetColumnDefs from "../components/ColumnDefs";
import { Button } from "@progress/kendo-react-buttons";
import { MultiSelect, DropDownList } from "@progress/kendo-react-dropdowns";
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import configData from "../config.json";
import { GetSession, GetToken } from "../components/Session";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import { Reveal } from "@progress/kendo-react-animation";
import { GetPermissions } from '../components/Options';
import Notifications from '../components/Notifications';
import { useNavigate } from "react-router-dom";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Upload } from '@progress/kendo-react-upload';
import { Label } from '@progress/kendo-react-labels';
import { filterBy } from "@progress/kendo-data-query";

const Jobs = () => {
    const [lookupParams, setLookupParams] = React.useState("");
    const [sources, setSources] = React.useState([]);
    const [source, setSource] = React.useState([]);
    const [destinations, setDestinations] = React.useState([]);
    const [destination, setDestination] = React.useState([]);
    const [sites, setSites] = React.useState([]);
    const [site, setSite] = React.useState([]);
    const [customers, setCustomers] = React.useState([]);
    const [customer, setCustomer] = React.useState([]);
    const [customerdata, setcustomerData] = React.useState();
    const statii = ["All", "Active", "Inactive"];
    const [status, setStatus] = React.useState("Active");
    const [expanded, setExpanded] = React.useState(false);
    const ready = React.useRef(false);
    const [columns, setColumns] = React.useState(null);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [permissions, setPermissions] = React.useState(null);
    const [showImport, setShowImport] = React.useState(false);
    const navigate = useNavigate();
    const options = React.useRef();
    const [uploadFile, setUploadFile] = React.useState("");
    const [message, setMessage] = React.useState("");
    const [result, setResult] = React.useState("");
    const [forceUpdate, setForceUpdate] = React.useState("");
    const showSites = GetSession().SiteID === 1;
    const [destdata, setdestData] = React.useState();
    const [srcdata, setsrcData] = React.useState();

    let dt = new Date();
    let dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 23, 59, 59) };
    const [dateRange, setDateRange] = React.useState(dr);
    const progressRef = React.useRef({});
    let js = localStorage.getItem("JobSearch");
    if (localStorage.getItem("userid") === null) navigate("/logout");

    if (permissions && !permissions.CanView) navigate("/error401");
    const [layout, setLayout] = React.useState([
        { "field": "searchAdvanced", "label": "Advanced Search", "isVisible": true },
        { "field": "searchSite", "label": "Site", "isVisible": true },
        { "field": "searchCustomer", "label": "Customer", "isVisible": true },
        { "field": "searchSource", "label": "Source", "isVisible": true },
        { "field": "searchDestination", "label": "Destination", "isVisible": true },
        { "field": "searchDate", "label": "Date Range", "isVisible": true },
        { "field": "searchStatus", "label": "Status", "isVisible": true },
    ]);

    const subTotals = [
        { field: 'cartageCostPerTonne', aggregate: 'average' },
        { field: 'cartagePerTonne', aggregate: 'average' },
        { field: 'minimumCharge', aggregate: 'average' },
        { field: 'overLoadFee', aggregate: 'average' },
        { field: 'tonnageFee', aggregate: 'average' },
        { field: 'jobTonnesRunningTotal', aggregate: 'sum' },
        { field: 'jobTonnesOrdered', aggregate: 'sum' }
    ];

    const GetField = (f) => {
        return layout.find(obj => { return obj.field === f });
    }

    function DoSearch() {
        if (ready.current) {
            var fd = (dateRange === undefined || dateRange.start === "" || dateRange.start === null) ? dr.start : dateRange.start.toISOString();
            var td = (dateRange === undefined || dateRange.end === "" || dateRange.end === null) ? dr.end : dateRange.end.toISOString();
            var jobParam = {
                Customer: GetIds(customer),
                Source: GetIds(source),
                Destination: GetIds(destination),
                Site: GetIds(site),
                FromDate: fd,
                ToDate: td,
                Status: status
            };
            setLookupParams(encodeURI(JSON.stringify(jobParam)));
            localStorage.setItem("JobSearch", JSON.stringify(jobParam));
        }
    }

    const GetIds = (d) => {
        if (d.length === undefined || d.length === 0) return "0";
        let r = "";
        d.map(x => {
            r += (r.length > 0 ? ";" : "") + x.id;
        });
        return r;
    }

    const ClearSearch = () => {
        if (ready.current) {
            ClearParams();
            var jobParam = {
                Source: null,
                Customer: null,
                Destination: null,
                Site: null,
                FromDate: dr.start,
                ToDate: dr.end,
                Status: "All"
            };
            setLookupParams(encodeURI(JSON.stringify(jobParam)));
            localStorage.removeItem("JobSearch");
        }
    }

    const ClearParams = () => {
        setCustomer([]);
        setSource([]);
        setDestination([]);
        setSite([]);
        setDateRange(dr);
        setStatus("Active");
    };
    const customerChanged = (event) => {
        setCustomer(event.target.value);
    };
    const sourceChanged = (event) => {
        setSource(event.target.value);
    };
    const destinationChanged = (event) => {
        setDestination(event.target.value);
    };
    const siteChanged = (event) => {
        setSite(event.target.value);
    };

    React.useEffect(() => {
        GetColumnDefs("jobs", setColumns, setErrorMessage);
        GetPermissions(["ViewJob", "NewJob", "EditJob", "DeleteJob", "ReportJob", "ImportJobs"], setPermissions)
        let baseUrl = configData.SERVER_URL + "apiv7/userinterfaces?$filter=viewName eq 'Jobs'";
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(baseUrl, init).then(response => response.json()).then(d => {
            if (GetSession().IsMobile) {
                let data = [];
                for (let i = 0; i < d.length; i++) {
                    data.push({ field: d[i].field, label: d[i].label, type: d[i].type, format: d[i].format, isVisible: d[i].isVisible && d[i].isVisibleOnMobile });
                }
                setLayout(data);
            } else {
                setLayout(d);
            }
        });
        baseUrl = configData.SERVER_URL + "apiv7/options";
        fetch(baseUrl, init)
            .then((response) => response.json())
            .then((d) => {
                options.current = d;
                setCustomers(d.customers);
                setcustomerData(d.customers);
                setSources(d.sources);
                setsrcData(d.sources);
                setDestinations(d.destinations);
                setdestData(d.destinations);
                setSites(d.sites);
                var jobParam = {
                    Customer: null,
                    Source: null,
                    Destination: null,
                    Site: null,
                    FromDate: dr.start,
                    ToDate: dr.end,
                    Status: "Active"
                };
                //        setLookupParams(encodeURI(JSON.stringify(jobParam)));
                if (js !== undefined && js !== "" && js !== null) {
                    setExpanded(true);
                    setTimeout(() => { UpdateSavedParams() }, 100);
                } else {
                    ClearParams();
                }
                ready.current = true;
            });
    }, []);

    const UpdateSavedParams = () => {
        if (js === undefined) return;
        let def = JSON.parse(js);
        let cs = GetSelected(options.current.customers, def.Customer);
        if (cs !== undefined && cs[0] === undefined) cs = [];
        setCustomer(cs);
        let st = GetSelected(options.current.sites, def.Site);
        if (st !== undefined && st[0] === undefined) st = [];
        setSite(st);
        let src = GetSelected(options.current.sources, def.Source);
        if (src !== undefined && src[0] === undefined) src = [];
        setSource(src);
        let dst = GetSelected(options.current.destinations, def.Destination);
        if (dst !== undefined && dst[0] === undefined) dst = [];
        setDestination(dst);
        dr = { start: new Date(def.FromDate), end: new Date(def.ToDate) };
        setDateRange(dr);
        setStatus(def.Status);
        var truckParam = {
            Customer: GetIds(cs),
            FromDate: dr.start.toISOString(),
            ToDate: dr.end.toISOString(),
            Site: GetIds(st),
            Source: GetIds(src),
            Destination: GetIds(dst),
            Status: def.Status
        };
        setLookupParams(encodeURI(JSON.stringify(truckParam)));
    }

    const GetSelected = (c, d) => {
        let r = [];
        if (d === undefined || d === null || d === "0") return r;
        let sp = d.split(';');
        sp.forEach(s => {
            let f = c.find(obj => { return obj.id === s });
            if (f !== undefined) r.push(f);
        });
        return r;
    }

    const ShowImport = () => {
        setShowImport(true);
        setMessage("");
    }

    const ImportFile = () => {
        const timeOffset = new Date().getTimezoneOffset() / 60;
        var url = `${configData.SERVER_URL}apiv7/import`;
        const init = {
            method: 'POST',
            accept: "application/json",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            mode: "cors",
            cache: "no-cache",
            body: JSON.stringify({
                "dataType": "job",
                "data": uploadFile,
                "siteId": GetSession().SiteID,
                "offset": timeOffset
            })
        }
        fetch(url, init).then(response => response.text()).then(d => {
            setShowImport(false);
            setResult(d);
            setForceUpdate(new Date());
        });

    }

    const [showDateRange, setShowDateRange] = React.useState(false);
    const rangeChanged = (event) => {
        const newRange = event.value;

        let dr = event.target.value;
        setDateRange(dr);

        if (newRange.start && newRange.end) {
            setShowDateRange(false);
        }
    };


    const onSave = (files, o, onProgress) => {
        const currentFile = files[0];
        const uid = currentFile.uid;
        progressRef.current[uid] = 0;
        files.push(currentFile);

        // Simulate save request
        return new Promise((resolve, reject) => {
            if (currentFile.validationErrors && currentFile.validationErrors.length > 0) {
                reject({ uid: uid });
            } else {
                const reader = new FileReader();
                reader.onload = () => {
                    if (reader.result && typeof reader.result === 'string') {
                        setUploadFile(reader.result);
                        setMessage("File Uploaded");
                        resolve({ uid: uid });
                    } else {
                        reject({ uid: uid });
                    }
                };
                reader.onprogress = (data) => {
                    onProgress(uid, data);
                };
                reader.onabort = () => {
                    reject({ uid: uid });
                };
                reader.onerror = () => {
                    reject({ uid: uid });
                };

                reader.readAsDataURL(currentFile.getRawFile());
            }
        });
    }

    const BulkStatus = (rec, st) => {
        let url = configData.SERVER_URL + `apiv7/jobs?jobList=${rec}&status=${st}`;
        const init = {
            method: 'PATCH',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(url, init).then(response => {
            setForceUpdate(new Date());
        });
    }

    const filtercustomerData = (filter) => {
        const customerdata = customers.slice();
        return filterBy(customerdata, filter);
    };

    const filtercustChange = (event) => {
        setcustomerData(filtercustomerData(event.filter));
    };

    const filterdesData = (filter) => {
        const desdata = destinations.slice();
        return filterBy(desdata, filter);
    };
    const filterdesChange = (event) => {
        setdestData(filterdesData(event.filter));
    };

    const filtersrctData = (filter) => {
        const srcdata = sources.slice();
        return filterBy(srcdata, filter);
    };
    const filtersrcChange = (event) => {
        setsrcData(filtersrctData(event.filter));
    };


    return (
        <div>
            <Notifications errorMessage={errorMessage} />
            {GetField("searchAdvanced")["isVisible"] && <ExpansionPanel
                title={GetField("searchAdvanced")["label"]}
                expandIcon="fa fa-plus"
                collapseIcon="fa fa-minus"
                expanded={expanded}
                onAction={(e) => setExpanded(!e.expanded)}
            >
                <Reveal className="revealz">
                    {expanded && (
                        <ExpansionPanelContent>
                            <div>
                                <div className="row" style={{ padding: "5px 10px" }}>
                                    {showSites && GetField("searchSite")["isVisible"] && <div className="col-md-3">
                                        <label className="control-label">{GetField("searchSite")["label"]}</label>
                                        <MultiSelect
                                            id="Site"
                                            data={sites}
                                            value={site}
                                            textField="name"
                                            dataItemKey="id"
                                            onChange={siteChanged}
                                        />
                                    </div>}
                                    {GetField("searchCustomer")["isVisible"] && <div className="col-md-3">
                                        <label className="control-label">{GetField("searchCustomer")["label"]}</label>
                                        <MultiSelect
                                            id="Customer"
                                            data={customerdata}
                                            value={customer}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filtercustChange}
                                            filterable={true}
                                            onChange={customerChanged}
                                        />
                                    </div>}
                                    {GetField("searchSource")["isVisible"] && <div className="col-md-3">
                                        <label className="control-label">{GetField("searchSource")["label"]}</label>
                                        <MultiSelect
                                            id="Source"
                                            data={srcdata}
                                            value={source}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filtersrcChange}
                                            filterable={true}
                                            onChange={sourceChanged}
                                        />
                                    </div>}
                                    {GetField("searchDestination")["isVisible"] && <div className="col-md-3">
                                        <label className="control-label">{GetField("searchDestination")["label"]}</label>
                                        <MultiSelect
                                            id="Destination"
                                            data={destdata}
                                            value={destination}
                                            textField="name"
                                            dataItemKey="id"
                                            onFilterChange={filterdesChange}
                                            filterable={true}
                                            onChange={destinationChanged}
                                        />
                                    </div>}
                                    {GetField("searchStatus")["isVisible"] && <div className="col-md-3">
                                        <label className="control-label">{GetField("searchStatus")["label"]}</label>
                                        <DropDownList
                                            id="Status"
                                            data={statii}
                                            value={status}
                                            onChange={e => setStatus(e.value)}
                                        />
                                    </div>}
                                </div>
                                <div className="row" style={{ padding: "5px 10px" }}>
                                    {GetField("searchDate")["isVisible"] && <div className="col-md-3">
                                        <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged} show={showDateRange} onFocus={() => setShowDateRange(true)} />
                                    </div>}
                                    <div className="col-md-3" style={{ padding: "25px" }}>
                                        <Button themeColor={"primary"} onClick={DoSearch}>
                                            Search
                                        </Button>{" "}
                                        <Button onClick={ClearSearch} themeColor={"primary"}>
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </ExpansionPanelContent>
                    )}
                </Reveal>
            </ExpansionPanel>}
            {showImport && <Dialog title="Import Jobs" onClose={() => setShowImport(false)}>
                <div className='row' style={{ padding: "10px 0px" }}>
                    <Label>Select import CSV or XLXS file</Label>
                </div>
                <div className='row' style={{ padding: "5px 0px", minWidth: "400px" }}>
                    <Upload multiple={false} saveUrl={onSave} />
                </div>
                <div className='row' style={{ padding: "10px 20px", color: "blue", fontWeight: "bold" }}>{message}</div>
                <DialogActionsBar>
                    <Button type="button" onClick={() => setShowImport(false)}>Cancel</Button>
                    <Button type="button" onClick={ImportFile}>Import Data</Button>
                </DialogActionsBar>
            </Dialog>}
            {result !== "" && <Dialog title="Import Result" onClose={() => setResult("")}>
                <div className='row' style={{ padding: "10px 0px" }}>
                    <div dangerouslySetInnerHTML={{ __html: result }}></div>
                </div>
                <DialogActionsBar>
                    <Button type="button" onClick={() => setResult("")}>Ok</Button>
                </DialogActionsBar>
            </Dialog>}
            {columns && permissions && permissions.CanView && <DataGrid
                dataSource="apiv7/jobs"
                params={lookupParams}
                columns={columns}
                permissions={permissions}
                keyField="jobId"
                extraButton="Add fee"
                extraButtonUrl="addextracharge"
                update={forceUpdate}
                bulkStatus={BulkStatus}
                subTotals={subTotals}
                importFile={permissions.ImportJobs ? ShowImport : undefined}
            />}
        </div>
    );
};

export default Jobs;
